import type { ExternalTableSchema } from '@packages/table-builder';

export const systemUsersTable: ExternalTableSchema = {
  metadata: {
    title: 'System Users',
    entity: 'system-user',
  },
  dataSource: {
    endpoint: '/api/customer/api/app/customer-user/customer-user-list',
    method: 'GET',
    rowIdField: 'customerUserId',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      Statuses: 'filters.status',
      IsEnabled: 'filters.isEnabled',
    },
    filters: [
      {
        name: 'status',
        semanticId: 'systemUsersFilterApprovalStatus',
        placeholder: 'Approval Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/customer/api/app/customer-user/customer-user-status-list',
          labelField: 'status',
          valueField: 'statusId',
        },
      },
      {
        name: 'isEnabled',
        semanticId: 'systemUsersFilterUserStatus',
        placeholder: 'User Status',
        type: 'select',
        multiple: true,
        options: [
          { label: 'Active', value: true },
          { label: 'Deactivated', value: false },
        ],
      },
    ],
  },
  columns: [
    {
      field: 'fullName',
      header: 'Employee Details',
      type: 'couple',
      width: 300,
      sortable: true,
      couple: { titleField: 'fullName', subtitleField: 'email' },
    },
    { field: 'email', header: 'Email', type: 'text', width: 200, visibility: 'picker' },
    { field: 'customerDepartment', header: 'Department', type: 'text', width: 200, sortable: true },
    { field: 'customerTitle', header: 'Job Title', type: 'text', width: 200, sortable: true },
    {
      field: 'customerRole',
      header: 'System Role',
      type: 'modal',
      width: 200,
      sortable: true,
      fields: { id: 'customerRoleId' },
      modal: { popoverInfo: { kind: 'Role' } },
    },
    {
      field: 'isEnabled',
      header: 'User Status',
      type: 'badge',
      width: 150,
      sortable: true,
      align: 'center',
      conditionalValues: { true: 'Active', false: 'Deactivated' },
      badge: { statusMap: { true: 'info', false: 'error' } },
    },
    {
      field: 'statusId',
      header: 'Status',
      type: 'badge',
      sortable: true,
      align: 'center',
      conditionalValues: { '1': 'Pending', '2': 'Approved', '3': 'Rejected' },
      badge: { statusMap: { '1': 'info', '2': 'success', '3': 'error' } },
    },
  ],
  actions: {
    toolbar: {
      primary: { id: 'ADD_SYSTEM_USER', label: 'Add user', icon: 'add_circle_outline' },
    },
    row: [
      { id: 'VIEW_SYSTEM_USER', label: 'View' },
      { id: 'EDIT_SYSTEM_USER', label: 'Edit' },
      { id: 'APPROVE_SYSTEM_USER', label: 'Approve' },
      { id: 'REJECT_SYSTEM_USER', label: 'Reject' },
      { id: 'DEACTIVATE_SYSTEM_USER', label: 'Deactivate', variant: 'danger' },
      { id: 'ACTIVATE_SYSTEM_USER', label: 'Activate' },
      { id: 'VIEW_COMMENTS_SYSTEM_USER', label: 'View Comments' },
      { id: 'RESEND_EMAIL_SYSTEM_USER', label: 'Resend Email' },
    ],
  },
  features: {
    search: { enabled: true, placeholder: 'Search' },
    filters: { enabled: true },
    filterGrid: { columns: 2 },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    columnPreferences: { persistenceKey: 'System Users', resizable: true, reorderable: true },
  },
};
